import DownloadSection from "./downloadSection/DownloadSection";
import FooterSection from "./footer/FooterSection";
import Hero from "./hero/Hero";
import MobileFeature from "./mobileFeature/MobileFeature";
import WhySection from "./whySection/WhySection";
import Navbar from "./navbar/Navbar";
import QuestionSection from "./questionSection/QuestionSection";

const PublicLayout = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <MobileFeature />
      <DownloadSection />
      <WhySection />
      <QuestionSection />
      <FooterSection />
    </div>
  )
}

export default PublicLayout;
